import { Hero } from './hero';

export class InteriorPageHero extends DrupalBehavior {
  onReady() {
    const breakpoint = window.matchMedia('(min-width: 768px)');
    const hero = new Hero('.interior-hero', breakpoint);

    breakpoint.addEventListener('change', hero.build());
  }
}

DrupalBehavior.register(
  'rush_theme.components',
  'interior_hero',
  InteriorPageHero
);
